import React from 'react';
import { Icon } from './Icon.js';
export const IconBedEmptyFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M5,12h12v-3.25c0-1.517-1.233-2.75-2.75-2.75H1.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h3.25v4.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M16.25,11.5H2.5V3.25c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V14.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-1.75H15.5v1.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-2.5c0-.414-.336-.75-.75-.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconBedEmptyFill18.js.map